// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_on-5";
export var filledCircle = "_on-4";
export var historyEntry = "_on-3";
export var messageSideLeft = "_on-1";
export var messageSideRight = "_on-2";
export var orderTrackingCarouselWrapper = "_on-6";
export var orderTrackingInfoContainer = "_on-0";